import { AutocompleteRenderInputParams } from '@mui/material/Autocomplete';

export const styleDropdown = (
  params: AutocompleteRenderInputParams
): AutocompleteRenderInputParams => {
  const inputPropsOverrides = {
    ...params.InputProps,
    disableUnderline: true,
  };

  const inputLabelPropsOverrides = {
    ...params.InputLabelProps,
    classes: {
      filled: 'input-label-filled',
      error: 'input-label-error',
      focused: 'input-label-focused',
    },
  };

  return {
    ...params,
    InputProps: inputPropsOverrides,
    InputLabelProps: inputLabelPropsOverrides,
  };
};
